 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		37: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		37: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendor~chunk-collections~chunk-discovery~chunk-solutions~chunk-vendor-details","1":"chunk-collections~chunk-solutions~chunk-vendor-details","2":"common-libs~chunk-discovery~chunk-manage-partner~chunk-solutions","3":"atlaskit-libs~@atlaskit-internal_media-client~@atlaskit-internal_media-viewer","4":"atlaskit-libs~chunk-app-listing~chunk-manage-partner","5":"common-libs~chunk-app-listing~chunk-manage-partner","6":"vendor~@atlaskit-internal_media-archive-viewer~@atlaskit-internal_media-pdf-viewer","7":"vendor~@atlaskit-internal_media-client~@atlaskit-internal_media-viewer","9":"@atlaskit-internal_Tooltip","10":"@atlaskit-internal_media-archive-viewer","11":"@atlaskit-internal_media-code-viewer","12":"@atlaskit-internal_media-pdf-viewer","13":"@atlaskit-internal_media-picker-error-boundary","14":"@atlaskit-internal_media-viewer","16":"atlaskit-libs~@atlaskit-internal_media-archive-viewer","17":"atlaskit-libs~@atlaskit-internal_media-code-viewer","18":"atlaskit-libs~@atlaskit-internal_media-viewer","20":"atlaskit-libs~chunk-app-listing","21":"atlaskit-libs~chunk-discovery","22":"atlaskit-libs~chunk-solutions","23":"atlaskit-libs~react-syntax-highlighter/refractor-import","24":"chunk-app-listing","25":"chunk-collections","26":"chunk-discovery","27":"chunk-manage-partner","28":"chunk-solutions","29":"chunk-support-ukraine-details","30":"chunk-vendor-details","31":"common-libs~@atlaskit-internal_media-code-viewer","33":"common-libs~chunk-app-listing","34":"common-libs~chunk-discovery","35":"common-libs~chunk-manage-partner","36":"common-libs~chunk-vendor-details","38":"tti-polyfill","39":"vendor~@atlaskit-internal_media-archive-viewer","40":"vendor~@atlaskit-internal_media-client-mobile-upload","41":"vendor~@atlaskit-internal_media-viewer","43":"vendor~chunk-collections","44":"vendor~pdfjsWorker","45":"vendor~react-syntax-highlighter/refractor-import"}[chunkId]||chunkId) + "." + {"0":"bdbfe9f62f2c0ad485be","1":"250f9a85d94c17c88b72","2":"3cae020cb6c2b8d38503","3":"0f8915ea534450c915ce","4":"ec7b68445baaad9c3fa5","5":"06596894b83a92c30f1b","6":"0b06e03fcb59dd98368c","7":"37715ffa494dca0ca729","8":"823141b4e4b9899061cf","9":"766eb22095e306619323","10":"1159eff13215da2c823a","11":"babe4b1411f69de1d42b","12":"3785418b5cae7be91819","13":"a702af0fc14ae6aff845","14":"71891b3b3df3648f8224","16":"9698898bab89ac16d35b","17":"765088b0a3f855f693a8","18":"81841121f63d007fd065","20":"b9bbbd615513343e5dad","21":"1e90da54aa52900e11f8","22":"d4d6bacdd7ab47b2439f","23":"e918feb4d9297dedce69","24":"f325b1e2a3dc0a8a2be3","25":"cc42e935ac69a381b00d","26":"e9b1776480dc284861da","27":"a9e1119806a4a4f7738f","28":"53ba2895fcf0a05504de","29":"d21743d987732fa0d0e6","30":"0239076f8a24aba74b21","31":"0757dafbbfcd8284c66b","33":"345e0849515b1c17b59d","34":"f4d85f4233c6e1d02e37","35":"1a040e4dc468c1afaaae","36":"42c0fa8d3417b28996a6","38":"342777f831bfd66b6473","39":"1f2d374a167d56596a75","40":"79cf8075075b018cd3c9","41":"d24633b280864f8facef","43":"e05dfccb411adf711d04","44":"7214b27e5ca0cc0f9017","45":"1ddc59ab6a488d61c559","46":"09b6cc79148c6174f811","47":"3f4ed93431f98d08aa5d","48":"be85956face622fd30c6","49":"1bef0fdc56056edc04d9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"25":1,"26":1,"28":1,"30":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendor~chunk-collections~chunk-discovery~chunk-solutions~chunk-vendor-details","1":"chunk-collections~chunk-solutions~chunk-vendor-details","2":"common-libs~chunk-discovery~chunk-manage-partner~chunk-solutions","3":"atlaskit-libs~@atlaskit-internal_media-client~@atlaskit-internal_media-viewer","4":"atlaskit-libs~chunk-app-listing~chunk-manage-partner","5":"common-libs~chunk-app-listing~chunk-manage-partner","6":"vendor~@atlaskit-internal_media-archive-viewer~@atlaskit-internal_media-pdf-viewer","7":"vendor~@atlaskit-internal_media-client~@atlaskit-internal_media-viewer","9":"@atlaskit-internal_Tooltip","10":"@atlaskit-internal_media-archive-viewer","11":"@atlaskit-internal_media-code-viewer","12":"@atlaskit-internal_media-pdf-viewer","13":"@atlaskit-internal_media-picker-error-boundary","14":"@atlaskit-internal_media-viewer","16":"atlaskit-libs~@atlaskit-internal_media-archive-viewer","17":"atlaskit-libs~@atlaskit-internal_media-code-viewer","18":"atlaskit-libs~@atlaskit-internal_media-viewer","20":"atlaskit-libs~chunk-app-listing","21":"atlaskit-libs~chunk-discovery","22":"atlaskit-libs~chunk-solutions","23":"atlaskit-libs~react-syntax-highlighter/refractor-import","24":"chunk-app-listing","25":"chunk-collections","26":"chunk-discovery","27":"chunk-manage-partner","28":"chunk-solutions","29":"chunk-support-ukraine-details","30":"chunk-vendor-details","31":"common-libs~@atlaskit-internal_media-code-viewer","33":"common-libs~chunk-app-listing","34":"common-libs~chunk-discovery","35":"common-libs~chunk-manage-partner","36":"common-libs~chunk-vendor-details","38":"tti-polyfill","39":"vendor~@atlaskit-internal_media-archive-viewer","40":"vendor~@atlaskit-internal_media-client-mobile-upload","41":"vendor~@atlaskit-internal_media-viewer","43":"vendor~chunk-collections","44":"vendor~pdfjsWorker","45":"vendor~react-syntax-highlighter/refractor-import"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"91cddf509ea4c6871884","26":"e194e0507c7785c86191","27":"31d6cfe0d16ae931b73c","28":"c983bd24c6a30f056d4e","29":"31d6cfe0d16ae931b73c","30":"cc6e4a98c4e36914e519","31":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/amkt-frontend-static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
